import { render, staticRenderFns } from "./reise-view-detail-header.vue?vue&type=template&id=312d6077"
import script from "./reise-view-detail-header.vue?vue&type=script&lang=js"
export * from "./reise-view-detail-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports